export const NFL_LEAGUES = [
  {
    id: 1,
    name: 'NFL',
    country: 'USA',
    flag: '🇺🇸'
  },
  {
    id: 2,
    name: 'NCAA',
    country: 'USA',
    flag: '🇺🇸'
  }
];
